/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InterviewActionItem
 */
export interface InterviewActionItem {
  /**
   *
   * @type {string}
   * @memberof InterviewActionItem
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof InterviewActionItem
   */
  assignee?: string | null;
}

/**
 * Check if a given object implements the InterviewActionItem interface.
 */
export function instanceOfInterviewActionItem(
  value: object,
): value is InterviewActionItem {
  if (!("content" in value) || value["content"] === undefined) return false;
  return true;
}

export function InterviewActionItemFromJSON(json: any): InterviewActionItem {
  return InterviewActionItemFromJSONTyped(json, false);
}

export function InterviewActionItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InterviewActionItem {
  if (json == null) {
    return json;
  }
  return {
    content: json["content"],
    assignee: json["assignee"] == null ? undefined : json["assignee"],
  };
}

export function InterviewActionItemToJSON(json: any): InterviewActionItem {
  return InterviewActionItemToJSONTyped(json, false);
}

export function InterviewActionItemToJSONTyped(
  value?: InterviewActionItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    content: value["content"],
    assignee: value["assignee"],
  };
}
